import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/logo/logo.svg'
import _imports_1 from '@/assets/images/illustrations/not_found.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_3 = { class: "bg-yellow-50 border-l-4 border-yellow-600 p-4 pl-6 rounded-md" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "luca-logo",
      height: "22",
      width: "35"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600 text-sm pt-1" }, " Báo cáo tháng chỉ có thể được báo cáo 1 tháng 1 lần ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z",
    fill: "#E5A42B"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "__report-lesson__container"
}
const _hoisted_9 = { class: "relative mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute inset-0 flex items-center",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-gray-300 mb-3.5" })
], -1)
const _hoisted_11 = { class: "relative flex justify-between" }
const _hoisted_12 = { class: "font-bold text-neutral-600 text-lg mb-3 bg-body pr-3" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  type: "button",
  class: "cursor-pointer button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 12.5L10 7.5L5 12.5",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "grid gap-8 mb-10 md-down:grid-cols-1 grid-cols-2 xl:grid-cols-4" }
const _hoisted_18 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center flex-nowrap\"><svg width=\"21\" height=\"20\" viewBox=\"0 0 21 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1704:5240)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.66797 1.66667C1.66797 0.746192 2.40767 0 3.32014 0H16.5375C17.45 0 18.1897 0.746192 18.1897 1.66667V8.81793C17.4244 8.50542 16.5878 8.33333 15.7114 8.33333C12.0616 8.33333 9.10275 11.25 9.10275 14.9319C9.10275 16.9231 9.96809 18.7784 11.3401 20H3.32014C2.40767 20 1.66797 19.2538 1.66797 18.3333V1.66667ZM2.9071 7.5C2.9071 7.26988 3.09203 7.08333 3.32014 7.08333H11.168C11.3961 7.08333 11.581 7.26988 11.581 7.5C11.581 7.73012 11.3961 7.91667 11.168 7.91667H3.32014C3.09203 7.91667 2.9071 7.73012 2.9071 7.5ZM2.9071 10C2.9071 9.76988 3.09203 9.58333 3.32014 9.58333H9.51579C9.74391 9.58333 9.92884 9.76988 9.92884 10C9.92884 10.2301 9.74391 10.4167 9.51579 10.4167H3.32014C3.09203 10.4167 2.9071 10.2301 2.9071 10ZM2.9071 12.5C2.9071 12.2699 3.09203 12.0833 3.32014 12.0833H7.86362C8.09174 12.0833 8.27666 12.2699 8.27666 12.5C8.27666 12.7301 8.09174 12.9167 7.86362 12.9167H3.32014C3.09203 12.9167 2.9071 12.7301 2.9071 12.5ZM2.9071 15C2.9071 14.7699 3.09203 14.5833 3.32014 14.5833H6.21145C6.43956 14.5833 6.62449 14.7699 6.62449 15C6.62449 15.2301 6.43956 15.4167 6.21145 15.4167H3.32014C3.09203 15.4167 2.9071 15.2301 2.9071 15ZM2.9071 3.75C2.9071 3.28976 3.27695 2.91667 3.73319 2.91667H14.8854C15.3416 2.91667 15.7114 3.28976 15.7114 3.75C15.7114 4.21024 15.3416 4.58333 14.8854 4.58333H3.73319C3.27695 4.58333 2.9071 4.21024 2.9071 3.75Z\" fill=\"#2AA797\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.7114 20C18.4489 20 20.668 17.7614 20.668 15C20.668 12.2386 18.4489 10 15.7114 10C12.974 10 10.7549 12.2386 10.7549 15C10.7549 17.7614 12.974 20 15.7114 20ZM17.5514 13.106C17.7328 12.923 18.027 12.923 18.2085 13.106C18.3877 13.2869 18.3899 13.5786 18.2151 13.7622L15.7417 16.8811C15.7381 16.8856 15.7343 16.8899 15.7302 16.894C15.5488 17.077 15.2546 17.077 15.0731 16.894L13.4334 15.2399C13.252 15.0569 13.252 14.7601 13.4334 14.577C13.6149 14.394 13.9091 14.394 14.0906 14.577L15.3877 15.8855L17.539 13.1201C17.5429 13.1151 17.547 13.1105 17.5514 13.106Z\" fill=\"#2AA797\"></path></g><defs><clipPath id=\"clip0_1704:5240\"><rect width=\"20\" height=\"20\" fill=\"white\" transform=\"translate(0.667969)\"></rect></clipPath></defs></svg><div class=\"text-neutral-500 text-sm ml-2\"> Báo cáo hoàn thành </div></div>", 1)
const _hoisted_20 = { class: "flex items-center flex-nowrap justify-between" }
const _hoisted_21 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_22 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center flex-nowrap\"><svg width=\"21\" height=\"20\" viewBox=\"0 0 21 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1704:5253)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.83073 0C1.91025 0 1.16406 0.746192 1.16406 1.66667V18.3333C1.16406 19.2538 1.91026 20 2.83073 20H10.921C9.53699 18.7784 8.66406 16.9231 8.66406 14.9319C8.66406 11.25 11.6488 8.33333 15.3307 8.33333C16.2148 8.33333 17.0587 8.50542 17.8307 8.81793V1.66667C17.8307 0.746192 17.0845 0 16.1641 0H2.83073ZM2.83073 7.08333C2.60061 7.08333 2.41406 7.26988 2.41406 7.5C2.41406 7.73012 2.60061 7.91667 2.83073 7.91667H10.7474C10.9775 7.91667 11.1641 7.73012 11.1641 7.5C11.1641 7.26988 10.9775 7.08333 10.7474 7.08333H2.83073ZM2.83073 9.58333C2.60061 9.58333 2.41406 9.76988 2.41406 10C2.41406 10.2301 2.60061 10.4167 2.83073 10.4167H9.08073C9.31085 10.4167 9.4974 10.2301 9.4974 10C9.4974 9.76988 9.31085 9.58333 9.08073 9.58333H2.83073ZM2.83073 12.0833C2.60061 12.0833 2.41406 12.2699 2.41406 12.5C2.41406 12.7301 2.60061 12.9167 2.83073 12.9167H7.41406C7.64418 12.9167 7.83073 12.7301 7.83073 12.5C7.83073 12.2699 7.64418 12.0833 7.41406 12.0833H2.83073ZM2.83073 14.5833C2.60061 14.5833 2.41406 14.7699 2.41406 15C2.41406 15.2301 2.60061 15.4167 2.83073 15.4167H5.7474C5.97751 15.4167 6.16406 15.2301 6.16406 15C6.16406 14.7699 5.97751 14.5833 5.7474 14.5833H2.83073ZM3.2474 2.91667C2.78716 2.91667 2.41406 3.28976 2.41406 3.75C2.41406 4.21024 2.78716 4.58333 3.2474 4.58333H14.4974C14.9576 4.58333 15.3307 4.21024 15.3307 3.75C15.3307 3.28976 14.9576 2.91667 14.4974 2.91667H3.2474Z\" fill=\"#94A3B8\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.3307 15C20.3307 17.7614 18.0922 20 15.3307 20C12.5693 20 10.3307 17.7614 10.3307 15C10.3307 12.2386 12.5693 10 15.3307 10C18.0922 10 20.3307 12.2386 20.3307 15ZM13.6767 12.904C13.5547 12.782 13.3568 12.782 13.2348 12.904C13.1127 13.0261 13.1127 13.2239 13.2348 13.346L14.8888 15L13.2348 16.654C13.1127 16.7761 13.1127 16.9739 13.2348 17.096C13.3568 17.218 13.5547 17.218 13.6767 17.096L15.3307 15.4419L16.9848 17.096C17.1068 17.218 17.3047 17.218 17.4267 17.096C17.5487 16.9739 17.5487 16.7761 17.4267 16.654L15.7727 15L17.4267 13.346C17.5487 13.2239 17.5487 13.0261 17.4267 12.904C17.3047 12.782 17.1068 12.782 16.9848 12.904L15.3307 14.5581L13.6767 12.904Z\" fill=\"#94A3B8\"></path></g><defs><clipPath id=\"clip0_1704:5253\"><rect width=\"20\" height=\"20\" fill=\"white\" transform=\"translate(0.332031)\"></rect></clipPath></defs></svg><div class=\"text-neutral-500 text-sm ml-2\"> Báo cáo chưa hoàn thành </div></div>", 1)
const _hoisted_24 = { class: "flex items-center flex-nowrap justify-between" }
const _hoisted_25 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_26 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center flex-nowrap" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M19.1364 1.75617L13.3136 18.0132C13.2441 18.2054 13.0618 18.3334 12.8575 18.3335H12.7022C12.5116 18.3335 12.338 18.224 12.2558 18.052L9.96547 13.1992C9.62823 12.4837 9.75876 11.6352 10.2954 11.0542L13.2068 7.87076C13.3855 7.68329 13.3855 7.38853 13.2068 7.20107L12.838 6.83225C12.6506 6.65354 12.3559 6.65354 12.1684 6.83225L8.9853 9.74396C8.40439 10.2807 7.55594 10.4112 6.84058 10.074L1.98826 7.78341C1.80114 7.71295 1.67479 7.5368 1.66801 7.33695V7.18165C1.65083 6.96328 1.78204 6.76047 1.98826 6.68666L18.2435 0.863249C18.4183 0.799069 18.6144 0.84055 18.7482 0.970012L19.0005 1.22236C19.1521 1.35486 19.2062 1.56728 19.1364 1.75617Z",
      fill: "#2AA797"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm ml-2" }, " Đã gửi PH ")
], -1)
const _hoisted_28 = { class: "flex items-center flex-nowrap justify-between" }
const _hoisted_29 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_30 = { class: "bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center flex-nowrap\"><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.8647 10.0003C12.8647 11.5824 11.5822 12.8649 10.0002 12.8649C8.4181 12.8649 7.13558 11.5824 7.13558 10.0003C7.13558 8.41826 8.4181 7.13574 10.0002 7.13574C11.5822 7.13574 12.8647 8.41826 12.8647 10.0003Z\" fill=\"#2AA797\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.833496 10.0003C0.833496 10.0003 4.271 3.69824 10.0002 3.69824C15.7293 3.69824 19.1668 10.0003 19.1668 10.0003C19.1668 10.0003 15.7293 16.3024 10.0002 16.3024C4.271 16.3024 0.833496 10.0003 0.833496 10.0003ZM10.0002 14.0107C12.2151 14.0107 14.0106 12.2152 14.0106 10.0003C14.0106 7.78543 12.2151 5.98991 10.0002 5.98991C7.78527 5.98991 5.98975 7.78543 5.98975 10.0003C5.98975 12.2152 7.78527 14.0107 10.0002 14.0107Z\" fill=\"#2AA797\"></path></svg><div class=\"text-neutral-500 text-sm ml-2\"> PH đã xem </div></div>", 1)
const _hoisted_32 = { class: "flex items-center flex-nowrap justify-between" }
const _hoisted_33 = { class: "text-neutral-600 font-bold text-4xl" }
const _hoisted_34 = {
  key: 0,
  class: "shadow-sm sm:rounded-2xl overflow-hidden"
}
const _hoisted_35 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_36 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_37 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Tên học sinh "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Trạng Thái "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Buổi học "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Kết quả "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Ngày áp dụng "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Gửi phụ huynh "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " PH đã xem ")
  ])
], -1)
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "px-3 py-4 text-center text-neutral-700" }
const _hoisted_41 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_42 = { class: "flex items-center cursor-pointer" }
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "text-xs font-medium leading-none text-white" }
const _hoisted_45 = { class: "ml-4 font-semibold text-orange-600 truncate" }
const _hoisted_46 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_47 = { class: "ml-6" }
const _hoisted_48 = {
  key: 0,
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_1706:5649)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.5 1.66667C1.5 0.746192 2.2397 0 3.15217 0H16.3696C17.282 0 18.0217 0.746192 18.0217 1.66667V8.81793C17.2564 8.50542 16.4199 8.33333 15.5435 8.33333C11.8936 8.33333 8.93478 11.25 8.93478 14.9319C8.93478 16.9231 9.80012 18.7784 11.1721 20H3.15217C2.2397 20 1.5 19.2538 1.5 18.3333V1.66667ZM2.73913 7.5C2.73913 7.26988 2.92406 7.08333 3.15217 7.08333H11C11.2281 7.08333 11.413 7.26988 11.413 7.5C11.413 7.73012 11.2281 7.91667 11 7.91667H3.15217C2.92406 7.91667 2.73913 7.73012 2.73913 7.5ZM2.73913 10C2.73913 9.76988 2.92406 9.58333 3.15217 9.58333H9.34783C9.57594 9.58333 9.76087 9.76988 9.76087 10C9.76087 10.2301 9.57594 10.4167 9.34783 10.4167H3.15217C2.92406 10.4167 2.73913 10.2301 2.73913 10ZM2.73913 12.5C2.73913 12.2699 2.92406 12.0833 3.15217 12.0833H7.69565C7.92377 12.0833 8.1087 12.2699 8.1087 12.5C8.1087 12.7301 7.92377 12.9167 7.69565 12.9167H3.15217C2.92406 12.9167 2.73913 12.7301 2.73913 12.5ZM2.73913 15C2.73913 14.7699 2.92406 14.5833 3.15217 14.5833H6.04348C6.2716 14.5833 6.45652 14.7699 6.45652 15C6.45652 15.2301 6.2716 15.4167 6.04348 15.4167H3.15217C2.92406 15.4167 2.73913 15.2301 2.73913 15ZM2.73913 3.75C2.73913 3.28976 3.10898 2.91667 3.56522 2.91667H14.7174C15.1736 2.91667 15.5435 3.28976 15.5435 3.75C15.5435 4.21024 15.1736 4.58333 14.7174 4.58333H3.56522C3.10898 4.58333 2.73913 4.21024 2.73913 3.75Z\" fill=\"#2AA797\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.5435 20C18.2809 20 20.5 17.7614 20.5 15C20.5 12.2386 18.2809 10 15.5435 10C12.8061 10 10.587 12.2386 10.587 15C10.587 17.7614 12.8061 20 15.5435 20ZM17.3834 13.106C17.5649 12.923 17.8591 12.923 18.0405 13.106C18.2198 13.2869 18.222 13.5786 18.0471 13.7622L15.5737 16.8811C15.5701 16.8856 15.5663 16.8899 15.5623 16.894C15.3808 17.077 15.0866 17.077 14.9051 16.894L13.2655 15.2399C13.084 15.0569 13.084 14.7601 13.2655 14.577C13.4469 14.394 13.7412 14.394 13.9226 14.577L15.2197 15.8855L17.3711 13.1201C17.3749 13.1151 17.379 13.1105 17.3834 13.106Z\" fill=\"#2AA797\"></path></g><defs><clipPath id=\"clip0_1706:5649\"><rect width=\"20\" height=\"20\" fill=\"white\" transform=\"translate(0.5)\"></rect></clipPath></defs>", 2)
const _hoisted_51 = [
  _hoisted_49
]
const _hoisted_52 = {
  key: 1,
  class: "text-orange-500",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.65217 0C1.7397 0 1 0.746192 1 1.66667V18.3333C1 19.2538 1.7397 20 2.65217 20H10.6721C9.30012 18.7784 8.43478 16.9231 8.43478 14.9319C8.43478 11.25 11.3936 8.33333 15.0435 8.33333C15.9199 8.33333 16.7564 8.50542 17.5217 8.81793V1.66667C17.5217 0.746192 16.782 0 15.8696 0H2.65217ZM2.65217 7.08333C2.42406 7.08333 2.23913 7.26988 2.23913 7.5C2.23913 7.73012 2.42406 7.91667 2.65217 7.91667H10.5C10.7281 7.91667 10.913 7.73012 10.913 7.5C10.913 7.26988 10.7281 7.08333 10.5 7.08333H2.65217ZM2.65217 9.58333C2.42406 9.58333 2.23913 9.76988 2.23913 10C2.23913 10.2301 2.42406 10.4167 2.65217 10.4167H8.84783C9.07594 10.4167 9.26087 10.2301 9.26087 10C9.26087 9.76988 9.07594 9.58333 8.84783 9.58333H2.65217ZM2.65217 12.0833C2.42406 12.0833 2.23913 12.2699 2.23913 12.5C2.23913 12.7301 2.42406 12.9167 2.65217 12.9167H7.19565C7.42377 12.9167 7.6087 12.7301 7.6087 12.5C7.6087 12.2699 7.42377 12.0833 7.19565 12.0833H2.65217ZM2.65217 14.5833C2.42406 14.5833 2.23913 14.7699 2.23913 15C2.23913 15.2301 2.42406 15.4167 2.65217 15.4167H5.54348C5.7716 15.4167 5.95652 15.2301 5.95652 15C5.95652 14.7699 5.7716 14.5833 5.54348 14.5833H2.65217ZM3.06522 2.91667C2.60898 2.91667 2.23913 3.28976 2.23913 3.75C2.23913 4.21024 2.60898 4.58333 3.06522 4.58333H14.2174C14.6736 4.58333 15.0435 4.21024 15.0435 3.75C15.0435 3.28976 14.6736 2.91667 14.2174 2.91667H3.06522Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.0435 20C17.7809 20 20 17.7614 20 15C20 12.2386 17.7809 10 15.0435 10C12.3061 10 10.087 12.2386 10.087 15C10.087 17.7614 12.3061 20 15.0435 20ZM15.0435 11.3542C14.4491 11.3542 13.864 11.502 13.3398 11.7847C12.8156 12.0673 12.3686 12.476 12.0384 12.9745C11.7082 13.473 11.505 14.046 11.4468 14.6426C11.3885 15.2393 11.477 15.8413 11.7045 16.3952C11.9319 16.9491 12.2913 17.4379 12.7507 17.8183C13.2101 18.1986 13.7555 18.4588 14.3384 18.5758C14.9213 18.6927 15.5239 18.6629 16.0926 18.4888C16.6614 18.3148 17.1788 18.0019 17.5991 17.578C17.6619 17.5146 17.7223 17.449 17.7801 17.3814L18.1711 17.7216C18.105 17.7988 18.036 17.8738 17.9641 17.9463C17.4838 18.4308 16.8925 18.7883 16.2425 18.9873C15.5925 19.1862 14.9039 19.2203 14.2377 19.0866C13.5715 18.9529 12.9482 18.6556 12.4232 18.2209C11.8981 17.7862 11.4874 17.2276 11.2275 16.5945C10.9675 15.9615 10.8664 15.2735 10.9329 14.5916C10.9995 13.9097 11.2318 13.2549 11.6091 12.6851C11.9865 12.1154 12.4974 11.6483 13.0964 11.3253C13.6955 11.0023 14.3642 10.8333 15.0435 10.8333C15.1451 10.8333 15.2465 10.8371 15.3473 10.8446L15.3094 11.364C15.2211 11.3575 15.1324 11.3542 15.0435 11.3542ZM16.3442 11.5985C16.1786 11.534 16.0085 11.482 15.8353 11.4428L15.9485 10.9346C16.1464 10.9794 16.3408 11.0389 16.53 11.1125L16.3442 11.5985ZM17.0514 11.9686C16.9774 11.9188 16.9019 11.8718 16.8249 11.8278L17.0794 11.3746C17.1674 11.4249 17.2537 11.4786 17.3382 11.5355C17.4227 11.5925 17.5049 11.6524 17.5847 11.7152L17.267 12.1258C17.1972 12.0709 17.1253 12.0184 17.0514 11.9686ZM17.9983 12.9007C17.8961 12.7543 17.7834 12.6157 17.661 12.486L18.0349 12.1269C18.1748 12.2751 18.3037 12.4335 18.4205 12.6008L17.9983 12.9007ZM18.3825 13.6048C18.3485 13.5219 18.3115 13.4405 18.2717 13.3608L18.7329 13.1266C18.7784 13.2178 18.8206 13.3108 18.8595 13.4055C18.8984 13.5002 18.9337 13.5961 18.9654 13.693L18.4752 13.8564C18.4474 13.7716 18.4165 13.6877 18.3825 13.6048ZM18.6565 14.9105C18.6522 14.7315 18.6347 14.5531 18.6044 14.3767L19.1131 14.2877C19.1478 14.4893 19.1677 14.6932 19.1727 14.8977L18.6565 14.9105ZM18.5882 15.7113C18.6055 15.6233 18.6196 15.5349 18.6304 15.4463L19.1429 15.51C19.1305 15.6113 19.1144 15.7123 19.0945 15.8129C19.0747 15.9134 19.0513 16.013 19.0243 16.1113L18.5267 15.9724C18.5503 15.8863 18.5708 15.7993 18.5882 15.7113ZM18.0969 16.9505C18.1918 16.7992 18.2756 16.6411 18.3476 16.4774L18.8196 16.6885C18.7374 16.8756 18.6416 17.0563 18.5331 17.2292L18.0969 16.9505ZM15.0435 12.6562C15.0435 12.5124 14.9279 12.3958 14.7853 12.3958C14.6428 12.3958 14.5272 12.5124 14.5272 12.6562V15.5208C14.5272 15.6143 14.5768 15.7006 14.6572 15.7469L16.4643 16.7886C16.5881 16.86 16.7458 16.8166 16.8165 16.6917C16.8873 16.5668 16.8443 16.4078 16.7205 16.3364L15.0435 15.3697V12.6562Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = {
  key: 2,
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_57 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_1739:6086)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.9987 0C2.07822 0 1.33203 0.746192 1.33203 1.66667V18.3333C1.33203 19.2538 2.07822 20 2.9987 20H11.089C9.70496 18.7784 8.83203 16.9231 8.83203 14.9319C8.83203 11.25 11.8168 8.33333 15.4987 8.33333C16.3828 8.33333 17.2267 8.50542 17.9987 8.81793V1.66667C17.9987 0.746192 17.2525 0 16.332 0H2.9987ZM2.9987 7.08333C2.76858 7.08333 2.58203 7.26988 2.58203 7.5C2.58203 7.73012 2.76858 7.91667 2.9987 7.91667H10.9154C11.1455 7.91667 11.332 7.73012 11.332 7.5C11.332 7.26988 11.1455 7.08333 10.9154 7.08333H2.9987ZM2.9987 9.58333C2.76858 9.58333 2.58203 9.76988 2.58203 10C2.58203 10.2301 2.76858 10.4167 2.9987 10.4167H9.2487C9.47882 10.4167 9.66536 10.2301 9.66536 10C9.66536 9.76988 9.47882 9.58333 9.2487 9.58333H2.9987ZM2.9987 12.0833C2.76858 12.0833 2.58203 12.2699 2.58203 12.5C2.58203 12.7301 2.76858 12.9167 2.9987 12.9167H7.58203C7.81215 12.9167 7.9987 12.7301 7.9987 12.5C7.9987 12.2699 7.81215 12.0833 7.58203 12.0833H2.9987ZM2.9987 14.5833C2.76858 14.5833 2.58203 14.7699 2.58203 15C2.58203 15.2301 2.76858 15.4167 2.9987 15.4167H5.91536C6.14548 15.4167 6.33203 15.2301 6.33203 15C6.33203 14.7699 6.14548 14.5833 5.91536 14.5833H2.9987ZM3.41536 2.91667C2.95513 2.91667 2.58203 3.28976 2.58203 3.75C2.58203 4.21024 2.95513 4.58333 3.41536 4.58333H14.6654C15.1256 4.58333 15.4987 4.21024 15.4987 3.75C15.4987 3.28976 15.1256 2.91667 14.6654 2.91667H3.41536Z\" fill=\"#94A3B8\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.4987 15C20.4987 17.7614 18.2601 20 15.4987 20C12.7373 20 10.4987 17.7614 10.4987 15C10.4987 12.2386 12.7373 10 15.4987 10C18.2601 10 20.4987 12.2386 20.4987 15ZM13.8447 12.904C13.7226 12.782 13.5248 12.782 13.4027 12.904C13.2807 13.0261 13.2807 13.2239 13.4027 13.346L15.0568 15L13.4027 16.654C13.2807 16.7761 13.2807 16.9739 13.4027 17.096C13.5248 17.218 13.7226 17.218 13.8447 17.096L15.4987 15.4419L17.1527 17.096C17.2748 17.218 17.4726 17.218 17.5947 17.096C17.7167 16.9739 17.7167 16.7761 17.5947 16.654L15.9406 15L17.5947 13.346C17.7167 13.2239 17.7167 13.0261 17.5947 12.904C17.4726 12.782 17.2748 12.782 17.1527 12.904L15.4987 14.5581L13.8447 12.904Z\" fill=\"#94A3B8\"></path></g><defs><clipPath id=\"clip0_1739:6086\"><rect width=\"20\" height=\"20\" fill=\"white\" transform=\"translate(0.5)\"></rect></clipPath></defs>", 2)
const _hoisted_59 = [
  _hoisted_57
]
const _hoisted_60 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = {
  key: 0,
  class: "px-3 py-4 whitespace-nowrap text-neutral-700"
}
const _hoisted_63 = { key: 0 }
const _hoisted_64 = {
  class: "px-3 py-4 whitespace-nowrap text-neutral-700",
  style: {"width":"150px"}
}
const _hoisted_65 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { class: "w-40" }
const _hoisted_71 = { class: "flex flex-nowrap items-center pr-10" }
const _hoisted_72 = {
  key: 2,
  class: "w-full h-full flex items-center justify-center flex-col"
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  height: "250",
  width: "250"
}, null, -1)
const _hoisted_74 = {
  key: 0,
  class: "text-neutral-500 text-lg text-center",
  style: {"max-width":"700px"}
}
const _hoisted_75 = {
  key: 1,
  class: "text-neutral-500 text-lg text-center",
  style: {"max-width":"700px"}
}
const _hoisted_76 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmSendMonthlyReport = _resolveComponent("ConfirmSendMonthlyReport")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_DaInfinityLoading = _resolveComponent("DaInfinityLoading")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DaModalFrame, {
      open: _ctx.isOpenModal,
      "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isOpenModal) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.isOpenModal && _ctx.modalType === _ctx.modalTypes.CREATE)
          ? (_openBlock(), _createBlock(_component_ConfirmSendMonthlyReport, {
              key: 0,
              onClose: _ctx.closeModal,
              onSubmit: _ctx.sendReport,
              name: _ctx.sendData?.order
            }, null, 8, ["onClose", "onSubmit", "name"]))
          : _createCommentVNode("", true),
        (_ctx.isOpenModal && _ctx.modalType === _ctx.modalTypes.ERROR)
          ? (_openBlock(), _createBlock(_component_Modal, {
              key: 1,
              onClose: _ctx.closeModal,
              data: _ctx.dataUncompleted,
              dataObject: _ctx.dataObject
            }, null, 8, ["onClose", "data", "dataObject"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("div", null, [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.alertShow)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createElementVNode("div", {
                        class: "top-1 right-2 absolute cursor-pointer",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.alertShow = false))
                      }, _hoisted_7)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.monthlyReports && _ctx.monthlyReports.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthlyReports, (lesson) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: lesson.date,
                      class: "mb-10"
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(`Tháng ${_ctx.$filters.toMMYYY(lesson.date)}`), 1),
                          _createElementVNode("div", {
                            class: "bg-body pl-3",
                            onClick: ($event: any) => (_ctx.showHide(lesson.date))
                          }, [
                            _createElementVNode("button", _hoisted_14, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["mr-1 transform", {
											'rotate-180': _ctx.isHides.includes(
												lesson.date
											),
										}])
                              }, _hoisted_16, 2),
                              _createElementVNode("span", null, _toDisplayString(_ctx.isHides.includes(lesson.date)
											? 'Mở rộng'
											: 'Thu gọn'), 1)
                            ])
                          ], 8, _hoisted_13)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(lesson.stats.completed || 0), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, _toDisplayString(lesson.stats.incomplete || 0), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, _toDisplayString(lesson.stats.sent_count || 0), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, _toDisplayString(lesson.stats
											.number_of_parents_read_monthly_report ||
										0), 1)
                          ])
                        ])
                      ]),
                      (!_ctx.isHides.includes(lesson.date))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("table", _hoisted_37, [
                                  _hoisted_38,
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lesson.data, (item, index) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        onClick: ($event: any) => (_ctx.checkOpenModal(item)),
                                        key: item.id,
                                        class: _normalizeClass([
												index % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											, "text-neutral-700 hover:bg-orange-50 cursor-pointer"])
                                      }, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("div", _hoisted_40, _toDisplayString(index + 1), 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_41, [
                                          _createElementVNode("div", _hoisted_42, [
                                            (
															item?.student
																?.profile_photo
																?.w200
														)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  class: "shadow-sm inline-block h-6 w-6 rounded-full",
                                                  src: 
															item?.student
																?.profile_photo
																?.w200
														,
                                                  alt: ""
                                                }, null, 8, _hoisted_43))
                                              : (_openBlock(), _createElementBlock("span", {
                                                  key: 1,
                                                  class: "inline-flex items-center justify-center h-6 w-6 rounded-full",
                                                  style: _normalizeStyle({
															background:
																item?.student
																	?.profile_photo
																	?.default
																	?.color,
														})
                                                }, [
                                                  _createElementVNode("span", _hoisted_44, _toDisplayString(item?.student
																	?.profile_photo
																	?.default
																	?.initial), 1)
                                                ], 4)),
                                            _createElementVNode("div", _hoisted_45, _toDisplayString(item?.student?.name), 1)
                                          ])
                                        ]),
                                        _createElementVNode("td", _hoisted_46, [
                                          _createElementVNode("div", _hoisted_47, [
                                            (
															item.state ===
															'completed'
														)
                                              ? (_openBlock(), _createElementBlock("svg", _hoisted_48, _hoisted_51))
                                              : (
															item.state ===
															'draft'
														)
                                                ? (_openBlock(), _createElementBlock("svg", _hoisted_52, _hoisted_55))
                                                : (_openBlock(), _createElementBlock("svg", _hoisted_56, _hoisted_59))
                                          ])
                                        ]),
                                        _createElementVNode("td", _hoisted_60, [
                                          (item?.lesson_count)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(item?.lesson_count), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        false
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_62, [
                                              (item?.skill_count)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(item?.goal_count), 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("td", _hoisted_64, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", {
                                              class: "mt-1 py-0.5 px-2.5 rounded-full text-neutral-700 h-fit w-fit font-semibold text-sm shadow-input",
                                              style: _normalizeStyle({
															background:
																_ctx.$filters.tagResult(
																	item?.average_result_in_percent
																)?.background,
															color: _ctx.$filters.tagResult(
																item?.average_result_in_percent
															)?.color,
														})
                                            }, " Đạt " + _toDisplayString(item?.average_result_in_percent) + " % ", 5)
                                          ])
                                        ]),
                                        _createElementVNode("td", _hoisted_65, [
                                          (item?.apply_date)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.$filters.formatDate2(
															item?.apply_date
														)), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("td", _hoisted_67, [
                                          (
														item.state ===
															'completed' &&
														!item.sent_at
													)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: _withModifiers(($event: any) => (
														_ctx.openSendConfirm(item)
													), ["stop"]),
                                                type: "button",
                                                class: "button-p text-center whitespace-nowrap w-fit btn--ghost"
                                              }, " Gửi báo cáo ", 8, _hoisted_68))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(item.sent_at
															? 'Đã gửi'
															: '-'), 1))
                                        ]),
                                        _createElementVNode("td", _hoisted_70, [
                                          _createElementVNode("div", _hoisted_71, _toDisplayString(item.numbers_of_parent_read ||
														0) + "/ " + _toDisplayString(item.total_parent_count ||
														0), 1)
                                        ])
                                      ], 10, _hoisted_39))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (_ctx.isInfinityLoading)
                    ? (_openBlock(), _createBlock(_component_DaInfinityLoading, {
                        key: 0,
                        onInfiniteLoad: _ctx.getMonthlyReports,
                        loaded: _ctx.stopLoad,
                        "is-loading": _ctx.isLoading
                      }, null, 8, ["onInfiniteLoad", "loaded", "is-loading"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _hoisted_73,
                  (!Object.keys(_ctx.$route.query)?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, " Báo cáo tháng được tạo tự động dựa vào các báo cáo buổi học cá nhân trong tháng. Bạn hãy bắt đầu báo cáo các buổi học can thiệp trên app Trị liệu viên, để có thể làm báo cáo tháng cho học sinh dựa vào những báo cáo đó nhé. "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_75, " Không tìm thấy kết quả phù hợp. "))
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_76, [
            _createVNode(_component_Loading)
          ]))
    ])
  ], 64))
}